import { takeLatest, call, put, all, cancelled } from "redux-saga/effects"
import _, { flatMap, filter, orderBy } from "lodash"
import axios from "axios"

import { sendTestMeasure } from "../../../services/measurement-create"

import {
  GET_DIVISIONS_WATCHER,
  GET_DESCENDANTS_WATCHER,
  POST_LOGO_EMAIL_WATCHER,
  POST_IMAGE_EMAIL_WATCHER,
  STEP_ONE_WATCHER,
  STEP_TWO_WATCHER,
  STEP_THIRD_WATCHER,
  STEP_FOURTH_WATCHER,
  STEP_FINISH_WATCHER,
  EDIT_MEASUREMENT_NAME_WATCHER,
  GET_LEADERS_WATCHER,
  GET_SURVEYS_TYPE_WATCHER,
  GET_MEASURE_WATCHER,
  GET_SEGMENTS_WATCHER,
  GET_SURVEY_TYPES_WATCHER,
  GET_SCOPE_TYPES_WATCHER,
  GET_ORGANIZATION_SURVEYS_WATCHER,
  UPDATE_MEASURE_WATCHER,
  STEP_MAIL_WATCHER,
  STEP_RECIPIENTS_WATCHER,
  STEP_DATACHECK_WATCHER,
  STEP_PREVIEW_WATCHER,
  STEP_SCHEDULE_WATCHER,
  STEP_COMPLETE_WATCHER,
  FORCE_SAVE_WATCHER,
  GET_EMPLOYEES_BY_SEGMENTS_WATCHER,
} from "./constants"
import {
  getDivisionsSuccess,
  getDivisionsFailed,
  getDescendantsSuccess,
  getDescendantsFailed,
  postLogoEmailSuccess,
  postLogoEmailFailed,
  postImageEmailSuccess,
  postImageEmailFailed,
  stepOneSuccess,
  stepOneFailed,
  stepTwoSuccess,
  stepTwoFailed,
  stepThirdFailed,
  stepFourthSuccess,
  stepFourthFailed,
  getLeadersSuccess,
  getLeadersFailed,
  getSurveysTypeSuccess,
  getMeasureSuccess,
  getMeasureFailed,
  getSegmentsSuccess,
  getSegmentsFailed,
  getSurveyTypesSuccess,
  getSurveyTypesFailed,
  getScopeTypesSuccess,
  getScopeTypesFailed,
  getOrganizationSurveysSuccess,
  getOrganizationSurveysFailed,
  updateMeasureSuccess,
  updateMeasureFailed,
  getMeasureWatcher,
  stepMailSuccess,
  stepMailFailed,
  stepRecipientsSuccess,
  stepRecipientsFailed,
  stepDatacheckSuccess,
  stepDatacheckFailed,
  stepPreviewSuccess,
  stepPreviewFailed,
  stepScheduleSuccess,
  stepScheduleFailed,
  stepCompleteSuccess,
  stepCompleteFailed,
  forceSaveSuccess,
  forceSaveFailed,
  getEmployeesBySegmentsSuccess,
  getEmployeesBySegmentsFailed,
  forceSaveWatcher,
} from "./actions"
import {
  LOCAL_COMPANY_ID,
  LOCAL_COMPANY_NAME,
  LOCAL_TOKEN,
} from "../../../utils/storage"

import {
  getScopeTypesApi,
  getSurveyTypesApi,
} from "../../../utils/routes/routes-survey"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

export function getEmployeesBySegmentsApi(params) {
  return axios.request({
    method: "GET",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/segments`,
    params,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

export function* getEmployeesBySegmentsSaga(action) {
  try {
    const { data, status } = yield call(
      getEmployeesBySegmentsApi,
      action.payload
    )
    if (status === 200) {
      yield put(getEmployeesBySegmentsSuccess(data.data))
    }
  } catch (error) {
    yield put(getEmployeesBySegmentsFailed())
    returnMessage(error)
  }
}

export function getSegmentsWithSurveysApi(id_survey_type) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }surveys/survey-has-segment?id_survey_type=${id_survey_type}&id_company=${LOCAL_COMPANY_ID()}`,
  })
}

export function* getSegmentsSaga(action) {
  try {
    const { data, status } = yield call(
      getSegmentsWithSurveysApi,
      action.payload
    )
    if (status === 200) {
      yield put(getSegmentsSuccess(data.data))
    }
  } catch (error) {
    yield put(getSegmentsFailed())
    returnMessage(error)
  }
}

export function* getSurveyTypesSaga() {
  try {
    const { data, status } = yield call(getSurveyTypesApi)
    if (status === 200) {
      yield put(getSurveyTypesSuccess(data.data))
    }
  } catch (error) {
    yield put(getSurveyTypesFailed())
    returnMessage(error)
  }
}

export function* getScopeTypesSaga() {
  try {
    const { data, status } = yield call(getScopeTypesApi)
    if (status === 200) {
      yield put(getScopeTypesSuccess(data.data))
    }
  } catch (error) {
    yield put(getScopeTypesFailed())
    returnMessage(error)
  }
}

export function getOrganizationSurveysApi(id_survey_type) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/available-surveys?id_survey_type=${id_survey_type}&scope_type=1`,
  })
}

export function* getOrganizationSurveysSaga(action) {
  try {
    const { data, status } = yield call(
      getOrganizationSurveysApi,
      action.payload
    )
    if (status === 200) {
      yield put(getOrganizationSurveysSuccess(data.data))
    }
  } catch (error) {
    yield put(getOrganizationSurveysFailed())
    returnMessage(error)
  }
}

export function getMeasureApi(id_measure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${id_measure}/wizard/initialize`,
  })
}

export function* getMeasureSaga(action) {
  try {
    const { data, status } = yield call(getMeasureApi, action.payload)
    if (status === 200) {
      yield put(getMeasureSuccess(data.data))
    }
  } catch (error) {
    yield put(getMeasureFailed())
    returnMessage(error)
  }
}

export function updateMeasureApi(data) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${data.id_measure}/wizard/initialize-edit`,
    data,
  })
}

export function* updateMeasureSaga(action) {
  try {
    const { data, status } = yield call(updateMeasureApi, action.payload)
    if (status === 200) {
      yield put(updateMeasureSuccess(data))
      yield put(getMeasureWatcher(data.measure_id))
    }
  } catch (error) {
    yield put(updateMeasureFailed())
    returnMessage(error)
  }
}

export function getDivisionsWatcherApi(param) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    cancelToken: param.token,
    params: {
      relation: "divisionparents",
      "filter[searchByName]": param.text ? param.text : "",
    },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/divisions`,
  })
}

function getEmployees(token) {
  return axios.request({
    method: "get",
    cancelToken: token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/employees`,
  })
}

export function getDivisionsWatcherApiv2(param) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    cancelToken: param.token,
    params: {
      relation: "divisionparents",
      "filter[searchByName]": param.text ? param.text : "",
    },
    url: `${process.env.API_URL}v2/companies/${LOCAL_COMPANY_ID()}/divisionstotal`,
  })
}

function getEmployeesv2(token) {
  return axios.request({
    method: "get",
    cancelToken: token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}v2/companies/${LOCAL_COMPANY_ID()}/totalemployees`,
  })
}


export function* getDivisionsWatcherSaga(action) {
  const cancelEmployees = axios.CancelToken.source()
  const cancelDivisions = axios.CancelToken.source()
  try {
    const obj = {
      text: action.payload,
      token: cancelDivisions.token,
    }
    const [{ data, status }, employees] = yield all([
      call(getDivisionsWatcherApiv2, obj),
      call(getEmployeesv2, cancelEmployees.token),
    ])

    // Sin búsqueda, la API devuelve el árbol completo desde la raíz y el
    // primer elemento es la división raíz de la compañía (a veces con
    // más de una división en level 0, de ahí el forzado a level 1).
    // Buscando por nombre (obj.text), el índice 0 es solo el primer match
    // y puede no ser la raíz — forzarlo rompía el árbol (padre inexistente)
    // y crasheaba MeasurementSelectRecipientTable/columns.js al renderizar.
    const isSearching = !!obj.text
    const dataMap = flatMap(data.data, (item, index) => {
      const isForcedRoot = !isSearching && index === 0
      return {
        ...item,
        employees: filter(
          employees.data.data,
          (employee) => employee.id_division == item.id_division
        ),
        id_parent: isForcedRoot
          ? null
          : item.divisionparents.length
          ? item.divisionparents[0].id_division
          : null,
        name_parent:
          item.level === 1
            ? item.company_name || LOCAL_COMPANY_NAME()
            : item.divisionparents.length
            ? item.divisionparents[0].name
            : null,
        level_parent: item.divisionparents.length
          ? item.divisionparents[0].level
          : "",
        level: isForcedRoot ? 1 : item.level,
      }
    })

    const dataTree = generateTree(dataMap)
    const payload = {
      dataTree,
      data: dataMap,
    }

    if (status === 200) {
      yield put(getDivisionsSuccess(payload))
    }
  } catch (error) {
    console.log(error)
    yield put(getDivisionsFailed())
  } finally {
    if (yield cancelled()) {
      cancelDivisions.cancel()
      cancelEmployees.cancel()
    }
  }
}

// POST LOGO IMAGE EMAIL
export function postLogoImageEmailApi({ idMeasurement, fd, type }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}/upload/${type}/email`,
    data: fd,
  })
}

export function* postLogoEmailSaga(action) {
  try {
    const { data, status } = yield call(postLogoImageEmailApi, action.payload)

    if (status === 200) {
      yield put(postLogoEmailSuccess(data.pathImage))
      // yield call(messageSuccess, 'Logo importado')
    }
  } catch (error) {
    yield call(messageFailed, "Error al cargar logo")
    yield put(postLogoEmailFailed())
  }
}

export function* postImageEmailSaga(action) {
  try {
    const { data, status } = yield call(postLogoImageEmailApi, action.payload)

    if (status === 200) {
      yield put(postImageEmailSuccess(data))
    }
  } catch (error) {
    yield call(messageFailed, "Error al cargar imagen")
    yield put(postImageEmailFailed())
  }
}

// GET DESCENDANTS ONE DIVISION
export function getDescendantsWatcherApi(idDivision) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/descendants/ids`,
  })
}

export function* getDescendantsWatcherSaga(action) {
  try {
    const { data, status } = yield call(
      getDescendantsWatcherApi,
      action.payload
    )

    if (status === 200) {
      return yield put(getDescendantsSuccess([...data.data, action.payload]))
    }
  } catch (error) {
    yield put(getDescendantsFailed())
  }
}

// step mail

export function stepMailWatcherApi({ idMeasure, data = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data,
    url: `${process.env.API_URL}measure/${idMeasure}/wizard/configure-mail`,
  })
}

export function* stepMailWatcherSaga(action) {
  try {
    const { status, data } = yield call(stepMailWatcherApi, action.payload)

    if (status === 200) {
      yield put(stepMailSuccess(data.data))
    }
  } catch (error) {
    yield put(stepMailFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// step recipients

export function stepRecipientsWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params,
    url: `${process.env.API_URL}measure/${idMeasurement}/wizard/recipients`,
  })
}

export function* stepRecipientsWatcherSaga(action) {
  try {
    const { status, data } = yield call(
      stepRecipientsWatcherApi,
      action.payload
    )
    if (status === 200) {
      yield put(stepRecipientsSuccess(data.data))
      yield put(
        forceSaveWatcher({ idMeasurement: action.payload.idMeasurement })
      )
    }
  } catch (error) {
    yield put(stepRecipientsFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// step datacheck

export function stepDatacheckWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params,
    url: `${process.env.API_URL}measure/${idMeasurement}/wizard/data-check`,
  })
}

export function* stepDatacheckWatcherSaga(action) {
  try {
    const { status, data } = yield call(stepDatacheckWatcherApi, action.payload)
    if (status === 200) {
      yield put(stepDatacheckSuccess(data.data))
    }
  } catch (error) {
    yield put(stepDatacheckFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// step preview

export function stepPreviewWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params,
    url: `${process.env.API_URL}measure/${idMeasurement}/wizard/preview`,
  })
}

export function* stepPreviewWatcherSaga(action) {
  try {
    const { status, data } = yield call(stepPreviewWatcherApi, action.payload)
    if (status === 200) {
      yield put(stepPreviewSuccess(data.data))
    }
  } catch (error) {
    yield put(stepPreviewFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// step schedule
export function stepScheduleWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: { ...params },
    url: `${process.env.API_URL}measure/${idMeasurement}/wizard/schedule`,
  })
}

export function* stepScheduleWatcherSaga(action) {
  try {
    const { status, data } = yield call(stepScheduleWatcherApi, action.payload)
    if (status === 200) {
      yield put(stepScheduleSuccess(data.data))
    }
  } catch (error) {
    yield put(stepScheduleFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// step complete

export function stepCompleteWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: { ...params },
    url: `${process.env.API_URL}measure/${idMeasurement}/wizard/schedule`,
  })
}

export function finalCompleteWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: { ...params },
    url: `${process.env.API_URL}measure/${idMeasurement}/wizard/complete-setup`,
  })
}

export function* stepCompleteWatcherSaga(action) {
  try {
    const { data } = yield call(stepCompleteWatcherApi, action.payload)
    const { status } = yield call(finalCompleteWatcherApi, action.payload)
    if (status === 200) {
      yield put(stepCompleteSuccess(data.data))
    }
  } catch (error) {
    yield put(stepCompleteFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// force save

export function forceSaveWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params,
    url: `${process.env.API_URL}measure/${idMeasurement}/wizard/force-save`,
  })
}

export function* forceSaveWatcherSaga(action) {
  try {
    const { status, data } = yield call(forceSaveWatcherApi, action.payload)
    if (status === 200) {
      yield put(forceSaveSuccess(data.data))
    }
  } catch (error) {
    yield put(forceSaveFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// STEP ONE
export function stepOneWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}/first/step`,
    data: { ...params },
  })
}

export function* stepOneWatcherSaga(action) {
  try {
    const { status, data } = yield call(stepOneWatcherApi, action.payload)

    if (status === 200) {
      yield put(stepOneSuccess(data.data))
    }
  } catch (error) {
    yield put(stepOneFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// STEP TWO
export function stepTwoWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}/second/step`,
    data: { ...params },
  })
}

export function* stepTwoWatcherSaga(action) {
  try {
    const { status, data } = yield call(stepTwoWatcherApi, action.payload)
    if (status === 200) {
      yield put(stepTwoSuccess(data.data))
    }
  } catch (error) {
    yield put(stepTwoFailed())
    yield call(messageFailed, "El tiempo de espera expiro.")
    returnMessage(error, true)
  }
}

// STEP THREE
export function* stepThirdWatcherSaga(action) {
  try {
    const { status, data } = yield call(sendTestMeasure, action.payload)
    if (status === 200) {
      yield call(messageSuccess, data.message)
    }
  } catch (error) {
    yield put(stepThirdFailed())
  }
}

// STEP FOURTH
export function stepFourthWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}/fourth/step`,
    data: { ...params },
  })
}

export function* stepFourthWatcherSaga(action) {
  try {
    const { data, status } = yield call(stepFourthWatcherApi, action.payload)
    if (status === 200) {
      yield put(stepFourthSuccess(data.data))
    }
  } catch (error) {
    yield put(stepFourthFailed())
  }
}

// FINISH MEASUREMENTE
export function stepFinishWatcherApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}/complete/step`,
    data: { ...params },
  })
}

export function* stepFinishWatcherSaga(action) {
  try {
    const data = yield call(stepFinishWatcherApi, action.payload)
  } catch (error) {
    yield put(stepFourthFailed())
  }
}

// MEASUREMENT EDIT NAME
export function editMeasurementNameApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "put",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}`,
    data: params,
  })
}

export function* editMeasurementNameSaga(action) {
  try {
    const { status, data } = yield call(editMeasurementNameApi, action.payload)
    const params = { idMeasurement: action.payload.idMeasurement }

    if (status === 200) {
      yield call(messageSuccess, "Los cambios han sido guardados.")
    }
    yield put(getMeasureWatcher(params))
    // yield put(stepOneWatcher(params))
  } catch (error) {}
}

// GET LEADERS
export function getTeamsApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/teams`,
  })
}

export function getLeadersApi(params) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: { segments: params.segments },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/teamleader`,
  })
}

export function* getLeadersSaga(action) {
  try {
    const [leaders, teams] = yield all([
      call(getLeadersApi, action.payload),
      call(getTeamsApi),
    ])

    const dataParsed = leaders.data.map((item) => {
      return {
        ...item,
        team: teams.data.filter(
          (collaborator) => collaborator.id_parent === item.id_position
        ),
      }
    })

    yield put(
      getLeadersSuccess(orderBy(dataParsed, ["employee_full_name"], ["asc"]))
    )
  } catch (error) {
    yield put(getLeadersFailed([]))
  }
}

// GET SURVEYS TYPE
export function getSurveysTypeApi(typeSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/surveys?filter[filterBySurveyType]=${typeSurvey}`,
  })
}

export function* getSurveysTypeSaga(action) {
  try {
    const { status, data } = yield call(getSurveysTypeApi, action.payload)

    if (status === 200) {
      yield put(getSurveysTypeSuccess(data.data))
    }
  } catch (error) {}
}

export default function* measurementCreateSaga() {
  yield takeLatest(GET_DIVISIONS_WATCHER, getDivisionsWatcherSaga)
  yield takeLatest(GET_DESCENDANTS_WATCHER, getDescendantsWatcherSaga)
  yield takeLatest(POST_LOGO_EMAIL_WATCHER, postLogoEmailSaga)
  yield takeLatest(POST_IMAGE_EMAIL_WATCHER, postImageEmailSaga)
  yield takeLatest(STEP_ONE_WATCHER, stepOneWatcherSaga)
  yield takeLatest(STEP_TWO_WATCHER, stepTwoWatcherSaga)
  yield takeLatest(STEP_THIRD_WATCHER, stepThirdWatcherSaga)
  yield takeLatest(STEP_FOURTH_WATCHER, stepFourthWatcherSaga)
  yield takeLatest(STEP_FINISH_WATCHER, stepFinishWatcherSaga)
  yield takeLatest(EDIT_MEASUREMENT_NAME_WATCHER, editMeasurementNameSaga)
  yield takeLatest(GET_LEADERS_WATCHER, getLeadersSaga)
  yield takeLatest(GET_SURVEYS_TYPE_WATCHER, getSurveysTypeSaga)

  yield takeLatest(GET_MEASURE_WATCHER, getMeasureSaga)
  yield takeLatest(GET_SEGMENTS_WATCHER, getSegmentsSaga)
  yield takeLatest(UPDATE_MEASURE_WATCHER, updateMeasureSaga)
  yield takeLatest(GET_SURVEY_TYPES_WATCHER, getSurveyTypesSaga)
  yield takeLatest(GET_SCOPE_TYPES_WATCHER, getScopeTypesSaga)
  yield takeLatest(GET_ORGANIZATION_SURVEYS_WATCHER, getOrganizationSurveysSaga)

  yield takeLatest(STEP_MAIL_WATCHER, stepMailWatcherSaga)
  yield takeLatest(STEP_RECIPIENTS_WATCHER, stepRecipientsWatcherSaga)
  yield takeLatest(STEP_DATACHECK_WATCHER, stepDatacheckWatcherSaga)
  yield takeLatest(STEP_PREVIEW_WATCHER, stepPreviewWatcherSaga)
  yield takeLatest(STEP_SCHEDULE_WATCHER, stepScheduleWatcherSaga)
  yield takeLatest(STEP_COMPLETE_WATCHER, stepCompleteWatcherSaga)
  yield takeLatest(FORCE_SAVE_WATCHER, forceSaveWatcherSaga)
  yield takeLatest(
    GET_EMPLOYEES_BY_SEGMENTS_WATCHER,
    getEmployeesBySegmentsSaga
  )
}

function generateTree(arr, parent_name, name) {
  const tree = []
  const mappedArr = {}
  let arrElem
  let mappedElem

  // First map the nodes of the array to an object -> create a hash table.
  for (let i = 0, len = arr.length; i < len; i++) {
    arrElem = arr[i]
    mappedArr[arrElem.id_division] = arrElem
    mappedArr[arrElem.id_division].children = []
  }

  for (const id in mappedArr) {
    if (mappedArr.hasOwnProperty(id)) {
      mappedElem = mappedArr[id]
      // If the element is not at the root level, add it to its parent array of children.
      if (mappedElem.id_parent) {
        if (mappedArr[mappedElem.id_parent]) {
          mappedArr[mappedElem.id_parent].children.push(mappedElem)
        }
      }
      // If the element is at the root level, add it to first level elements array.
      else {
        tree.push(mappedElem)
      }
    }
  }
  return tree
}
